module.exports = __webpack_public_path__ + "img/branding-preview-thumbnail.bf7fba88.jpg";